exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-4f56ab7f]{display:-ms-grid;display:grid;-ms-grid-rows:(44px)[2];grid-template-rows:repeat(2,44px);row-gap:9px}@media only screen and (min-width:760px){.footer[data-v-4f56ab7f]{-ms-grid-columns:(minmax(200px,1fr))[2];grid-template-columns:repeat(2,minmax(200px,1fr));gap:0 36px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f56ab7f","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newprogram/components/footer/Footer.vue
// module id = 68455cbc987bcecf5b04
// module chunks = 10